import { FormattedMessage } from "react-intl";
import {
  Row,
  Container,
  Column,
  ActionBar,
  useUser,
  List,
  withFlipper,
} from "lcm-iot-commons";
import isElementHiddenViaFlipper from "lcm-iot-commons/client/lib/utils/flipperUtils";
import AdministrationsItem from "./AdministrationItem";

type Props = {
  flipper: {
    hideAdministrationFus?: boolean;
  };
};

export function Administration({ flipper }: Props) {
  const user = useUser();

  const administrations = [
    {
      titleId: "usergroups.header",
      descriptionId: "usergroups.description",
      type: "team",
      href: "/usergroups",
    },
    {
      titleId: "tenants.header",
      descriptionId: "tenants.description",
      type: "tenant",
      href: "/tenants",
    },
    {
      titleId: "products.header",
      descriptionId: "products.description",
      type: "product",
      href: "/products",
    },
  ];

  if (user?.userRoles?.find((ur) => ur.name === "controlling_director")) {
    administrations.push({
      titleId: "taxes.header",
      descriptionId: "taxes.description",
      type: "tax-rounded",
      href: "/taxes",
    });
  }

  if (!isElementHiddenViaFlipper(flipper, "hideAdministrationFus")) {
    administrations.push({
      titleId: "administration.fus.title",
      descriptionId: "administration.fus.description",
      type: "fus",
      href: "/app/fus",
      // @ts-expect-error TS(2345) FIXME: Argument of type '{ titleId: string; descriptionId... Remove this comment to see the full error message
      external: true,
    });
  }

  if (
    user?.userRoles.find((ur) => ur.name === "firmware_update_service_admin")
  ) {
    administrations.push({
      titleId: "administration.fum.title",
      descriptionId: "administration.fum.description",
      type: "fum",
      href: "/app/fum",
      // @ts-expect-error TS(2345) FIXME: Argument of type '{ titleId: string; descriptionId... Remove this comment to see the full error message
      external: true,
    });
  }

  if (user?.userRoles.find((role) => role.name === "reseller_admin")) {
    administrations.push({
      titleId: "administration.userroles.title",
      descriptionId: "administration.userroles.description",
      type: "team",
      href: "/userrole",
    });
  }

  if (user?.userRoles.find((role) => role.name === "reseller")) {
    administrations.push({
      titleId: "administration.reseller.title",
      descriptionId: "administration.reseller.description",
      type: "team",
      href: "/reseller/subscriptions",
    });
    administrations.push({
      titleId: "administration.reseller.customers",
      descriptionId: "administration.reseller.customers.description",
      type: "user",
      href: "/reseller/customers",
    });
  }

  return (
    <Container>
      <Row>
        <Column>
          <ActionBar>
            <h1 id="administration-header">
              <FormattedMessage id="label.administration" />
            </h1>
          </ActionBar>
        </Column>
      </Row>
      <Row>
        <List id="administration-list">
          {administrations.map((administration) => (
            <AdministrationsItem
              administration={administration}
              key={administration.titleId}
            />
          ))}
        </List>
      </Row>
    </Container>
  );
}

export default withFlipper(Administration);
